import { useEffect, useState } from "react";
import { Text, Button, HStack, Menu, ScrollView, Input, View } from "native-base";
import { useTranslation } from "react-i18next";
import { AiOutlineCheck } from "react-icons/ai";
import { BsChevronDown } from "react-icons/bs";
import colors from "theme/colors";
import { IoMdSearch } from "react-icons/io";
import { isArrayOfStrings } from "utils/helpers";
import { logEvent } from "./logFormMenu";

function shouldShowSearchInput(shouldShowSearch, searchPlaceholder, search, setSearch) {
  return (
    shouldShowSearch && (
      <View px="12px" mb="5px">
        <Input
          variant="outline"
          size="md"
          width="100%"
          placeholder={searchPlaceholder ?? ""}
          value={search}
          onChange={(e) => setSearch(e?.target?.value)}
          InputRightElement={<IoMdSearch size="16px" color={colors.neutral.charcoal} />}
        />
      </View>
    )
  );
}

function shouldShowMenuItem(menuProps) {
  const {
    shouldShowSearch,
    filteredData,
    data,
    isPayDateSection,
    t,
    setValue,
    amplitude,
    isUpdate,
    shouldShowCheckIcon,
    value,
    testID,
  } = menuProps;
  return (shouldShowSearch ? filteredData : data)?.map((item) => {
    const mappedValue =
      typeof item === "string" || typeof item === "number"
        ? isPayDateSection && (item === "-1" || item === -1)
          ? t("home.list.rows.endMonth")
          : item
        : item?.name || item?.bankName || t(`home.statusReason.${item?.categoryName}`);
    return (
      <Menu.Item
        testID={testID}
        onPress={() => {
          if (setValue) {
            logEvent({
              eventname: "menuItem",
              amplitude,
              isUpdate,
              item,
            });
            setValue(item);
          }
        }}
      >
        <HStack width="100%" alignItems="center" justifyContent="space-between">
          <Text>{mappedValue}</Text>
          {shouldShowCheckIcon && value === mappedValue && (
            <AiOutlineCheck size="12px" color={colors.secondary.orchid} />
          )}
        </HStack>
      </Menu.Item>
    );
  });
}

const FormMenu = ({
  testID,
  value,
  data,
  setValue,
  isError,
  amplitude,
  isDisabled = false,
  isUpdate = false,
  shouldShowCheckIcon = false,
  placeholder,
  searchPlaceholder = "",
  shouldShowSearch = false,
  isPayDateSection = false,
}) => {
  const { t } = useTranslation("common");
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState(data);

  useEffect(() => {
    if (isArrayOfStrings(data) && shouldShowSearch) {
      setFilteredData(data.filter((item) => item.toLowerCase().includes(search.toLowerCase())));
    }
  }, [search]);

  const renderTriggerMenuItem = (triggerProps) => {
    return (
      <HStack
        alignItems="center"
        borderWidth={isError ? "2" : "1"}
        borderRadius={4}
        // backgroundColor={
        //   isDisabled ? colors.disabled.smoke : colors.neutral.cotton
        // } - TODO: commented for now as smoke color background for disabled is not reflecting in Datepicker. Discussed this with Alver.
        opacity={isDisabled ? 0.5 : 1}
        borderColor={isError ? "error.600" : colors.disabled.smoke}
        justifyContent="space-between"
        pr="10px"
        h="35px"
        width="100%"
      >
        <Button
          testID={testID}
          variant="ghost"
          w="95%"
          justifyContent="space-between"
          h="30px"
          disabled={isDisabled}
          onPress={() => {
            logEvent({
              eventname: "button",
              amplitude,
              isUpdate,
            });
          }}
          {...triggerProps}
        >
          <Text variant="xs" color={value ? "black" : colors.neutral.darkMist}>
            {!value && placeholder}
            {isPayDateSection && (value === "-1" || value === -1) ? t("home.list.rows.endMonth") : value || ""}
          </Text>
        </Button>
        <BsChevronDown size="17px" />
      </HStack>
    );
  };
  return (
    <Menu
      trigger={renderTriggerMenuItem}
      shouldFlip
      style={{
        width: "250px",
        maxHeight: "300px",
        backgroundColor: isDisabled ? colors.disabled.smoke : colors.neutral.cotton,
      }}
    >
      <ScrollView>
        {shouldShowSearchInput(shouldShowSearch, searchPlaceholder, search, setSearch)}
        {shouldShowMenuItem({
          shouldShowSearch,
          filteredData,
          data,
          isPayDateSection,
          t,
          setValue,
          amplitude,
          isUpdate,
          shouldShowCheckIcon,
          value,
          testID,
        })}
      </ScrollView>
    </Menu>
  );
};

export default FormMenu;
